import { ReactNode } from "react";
import styles from "@/pages/index.module.css";
import logoUrl from "@/images/logo.webp";

export function Logo(): ReactNode {
  return <img className={styles.logo} src={logoUrl} alt="DoodlyCoo" />;
}
